import * as React from "react";
import * as moment from "moment";
import Swiper from 'react-id-swiper';
import { api, user, guardAuth } from "src/services/api";
import { redirect, route, routeApi } from "src/services/browser";
import { classNames, __, __BETA, __TRIAL_DATE } from "src/services/theme";
import { alert, notify } from "src/services/notify";
import { FormState, Form, Fieldset, bindToAPI, resetState, _ } from "src/services/form";
import { Formatters, Loading, Modal } from "src/components/ui";
import OrdineCheckout from "./OrdineCheckout";

import Free from "./AcquistiScuolaInfo/Free";
import Premium from "./AcquistiScuolaInfo/Premium";
import Adwords from "./AcquistiScuolaInfo/Adwords";
import Adsp from "./AcquistiScuolaInfo/Adsp";

interface Props {
  abbonamento: any;
  scuola?: any;
  afterSign?: Function;
  onAdsp?: Function;
  onAdwords?: Function;
}

interface State {
  phase: string;
  choose?: any;
  scuola?: any;
  scuole?: any[];
  tmp_scuola?: any;
  focus?: string;
  trialStatus?: "loading" | "active";
}

export default class AcquistiScuola extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      phase: "INDEX"
    };
  }
  
  async componentDidMount() {
    if (user) {
      const args = {
        id_gestore: user.id,
        ipp: 100000000000,
        stato: ['Pubblicato']
      };
      const scuole = await api({
            url: "scuola",
            params: args
      });
      if (this.props.scuola) {
        await this.chooseScuola({values: {id_scuola: parseInt(this.props.scuola)}});
        //scuola = scuole.filter( s => s.id === parseInt(this.props.scuola) )[0];
      }
      this.setState({
        scuole
      })
    }
    
    let hash = window.location.hash;
    if (hash) { hash = hash.substr(1); }
    if (hash === "trial") {
      this.focus('premium');
      self.location.href = '#trial';
    }
    if (hash === "premium") {
      this.focus('premium');
      self.location.href = '#premium';
    }
  }
  
  focus( product ) {
    this.setState({
      focus: product
    });
  }

  async loadScuola( id ) {
    const item = await api({
        url: routeApi('scuola.show', { scuola: id }),
        method: 'get'
    });
    this.setState({
      scuola: item,
      trialStatus: item.trial ? 'active' : undefined
    });
    return item;
  }
  
  async chooseScuola( { values } ) {
    const { id_scuola } = values;
    //const item = this.state.scuole!.filter( s => s.id === id_scuola )[0];
    const item = await this.loadScuola( id_scuola );
    return item;
  }
  
  continue( phase, args? ) {
    const { scuola } = this.state;
    
    const cb = (scuola) => {
      if (phase === "TRIAL") {
        this.submitTrial();
        return;
      }
      if (phase === "EDIT") {
        redirect( route('profile.scuola.edit', { 'scuola': scuola.id } ) );
        return;
      }
      if (__BETA) {
        alert( { text: __('AcquistiScuola.coming_soon'), type: 'success' } );
        this.setState({
          choose: null
        });
        return;
      }
      if (phase === "ADSP") {
        const fn = `on${args.type === "ADSP" ? "Adsp" : "Adwords"}`;
        if (this.props[fn]) {
          this.props[fn]({id: scuola.id});
        }
      }
      this.setState({
        phase,
        scuola,
        choose: null
      });
    }
    if (guardAuth(this.props.afterSign as any)) {
      if (!scuola) {
        this.setState({
          choose: cb
        });
      } else {
        cb( scuola );
      }
    }
  }
  
  reset() {
    this.setState({
      phase: "INDEX",
      scuola: null,
      tmp_scuola: null,
      choose: null
    })
  }
  
  submitAbbonamento( { indirizzo, coupon } ) {
    const { abbonamento } = this.props;
    const { scuola } = this.state;
    api({
      method: "POST",
      url: "abbonamento/prePay",
      data: {
        recipient_id: scuola.id,
        recipient_type: 'scuola',
        prodotto: abbonamento.id,
        indirizzo
      },
      appActions: true
    });
  }
  
  async submitTrial( ) {
    const { abbonamento } = this.props;
    const { scuola } = this.state;
    this.setState({
      trialStatus: "loading",
      choose: null
    });
    const res = await api({
      method: "POST",
      url: "abbonamento/trial",
      data: {
        recipient_id: scuola.id,
        recipient_type: 'scuola',
        prodotto: abbonamento.id,
      },
      appActions: true
    });
    this.setState({
      trialStatus: "active",
    });
    
    notify( { text: 'Free trial attivato', type: 'success' } );
  }
  
  render() {
    const { abbonamento } = this.props;
    const { phase, scuole, scuola, choose, tmp_scuola, focus = "", trialStatus = null } = this.state;
    
    const swiperParams = {
      slidesPerView: 4,
      spaceBetween: 0,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0
        },
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
    }
    
    return (
      <div className="ecommerce_AcquistiScuola">
        <div className="ecommerce_Cover">
          <div>
            <div className="container">
              <h3><strong>Visor</strong> for Business</h3>
              <p>Con i piani Visor For Business sarai in cima nel nostro mondo.<br />
              In cima tra i leader.</p>
            </div>
          </div>
        </div>
        <a id="up" />
        {phase === "INDEX" &&
        <>
        <div className="container">
          <section>
            {user &&
            <header className="chooser">
              {user.thumb &&
              <figure className="avatar"><span className="fit">
                <img src={user.thumb} />
              </span></figure>
              }
              {!user.thumb &&
              <figure className="noavatar">
                <img src="/static/pages/ecommerce/user.png" />
              </figure>
              }
              <span>Ciao <strong>{user.nome}</strong>, a che scuola vuoi abbinare i tuoi piani business?</span>
              {scuole && scuole.length > 0 &&
              <Form onChange={values => this.chooseScuola(values)} defaultValues={scuola ? {id_scuola: scuola.id} : {}} render={(form) => {
                return (
                  <form onSubmit={form.submitForm}>
                    <Fieldset
                      fieldsParams={{
                        'id_scuola': { type: 'select', options: _.pluck(scuole, "nome") },
                      } as any}
                    />
                  </form>
                )
              }} />
              }
              {!scuole || scuole.length === 0 &&
              <div className="no-items">Per provare gratis Premium devi avere una scuola pubblicata</div>
              }
            </header>
            }
            {!user &&
            <header className="chooser">
              <div className="no-items">Registrati o autenticati per acquistare i servizi</div>
            </header>
            }
            <div className="products">
            <Swiper {...swiperParams}>
              <div className="product">
                <article className="grey">
                  <h3>Free Visor</h3>
                  <p>
                   La scheda con le informazioni essenziali della tua scuola online, gratis per sempre. 
                  </p>
                  <div className="price">
                    <div><strong>Gratis</strong> per sempre</div>
                  </div>
                  <div>
                    <a href="#focus" className="btn sm btn-block cancel" onClick={() => this.focus("free")}><span>Scopri</span></a>
                  </div>
                </article>
              </div>
              <div className="product">
                <article className="blue">
                  <h3>Premium Visor</h3>
                  <p>
                  La scheda della tua scuola ricca di funzioni e dettagli.
                  </p>
                  {!__BETA &&
                  <div className="price">
                    <div><strong>120 crediti</strong> / anno</div>
                    <div><small>&euro;</small> <strong>0,99</strong> / giorno</div>
                  </div>
                  }
                  {__BETA && __TRIAL_DATE &&
                  <div className="price"><strong>GRATIS FINO AL {moment(__TRIAL_DATE).format('DD/MM/YYYY')}</strong></div>
                  }
                  <div>
                    <a href="#focus" className="btn sm btn-block cancel" onClick={() => this.focus("premium")}><span>Scopri</span></a>
                  </div>
                </article>
              </div>
              <div className="product">
                <article className="orange">
                  <h3>Visor Vetrina</h3>
                  <p>
                  La tua scuola nella migliore vetrina multimediale.
                  </p>
                  {!__BETA &&
                  <div className="price">
                    <div>da <strong>10 crediti</strong> / giorno</div>
                  </div>
                  }
                  {__BETA && <div className="price"><strong>COMING SOON</strong></div>}
                  <div>
                    <a href="#focus" className="btn sm btn-block cancel" onClick={() => this.focus("adsp")}><span>Scopri</span></a>
                  </div>
                </article>
              </div>
              <div className="product">
                <article className="green">
                  <h3>Visor AD Words</h3>
                  <p>
                 La tua scuola in vetta alle ricerche.
                  </p>
                  {!__BETA &&
                  <div className="price">
                    <div>da <strong>10 crediti</strong> / giorno</div>
                  </div>
                  }
                  {__BETA && <div className="price"><strong>COMING SOON</strong></div>}
                  <div>
                    <a href="#focus" className="btn sm btn-block cancel" onClick={() => this.focus("adwords")}><span>Scopri</span></a>
                  </div>
                </article>
              </div>
            </Swiper>
            </div>
          </section>
        </div>
        <a id="focus" />
        {focus &&
        <div className="scrollDown">
          <a href="#focus"><span className="icon-expand_arrow" /></a>
        </div>
        }
        {focus === "free" &&
        <Free onClick={() => this.focus("premium")} />
        }
        {focus === "premium" &&
        <Premium activated={scuola && scuola.acquisti && scuola.acquisti.abbonamento ? true : false} onClick={() => this.continue("ABBONAMENTO")} trialStatus={trialStatus} onTrial={() => this.continue("TRIAL")} onEdit={() => this.continue("EDIT")} />
        }
        {focus === "adsp" &&
        <Adsp onClick={() => this.continue("ADSP", { type: 'ADSP'} )} />
        }
        {focus === "adwords" &&
        <Adwords onClick={() => this.continue("ADSP", { type: 'ADWORDS'} )} />
        }
        </>
        }
        
        {phase === "ABBONAMENTO" &&
        <section>
          <div className="container">
            <OrdineCheckout
              items={[{
                ...abbonamento,
                prezzo: abbonamento.prezzo.scuola,
                descrizione: `
                Attivazione: ${Formatters.Date({date:abbonamento.DataInizio})}<br />
                Rinnovo automatico: ${Formatters.Date({date:abbonamento.DataRinnovo})}
                `
              }]}
              onSubmit={(args) => this.submitAbbonamento(args)}
              onBack={() => this.reset()}
            />
            </div>
        </section>
        }
        {choose && scuole &&
        <Modal
          open={true}
          backdrop={true}
          icon={!user.thumb ? "user" : null}
          iconImg={user.thumb || null}
          className="ecommerce_AcquistiScuola_choose ecommerce_AcquistiScuola_bigheader"
          onClose={() => this.setState({choose: null})}
        >
            <header>
              <h2>{user.nome}</h2>
              <p>A quale delle tue strutture vuoi abbinare i servizi Visor For Business?</p>
            </header>
            <div className="list">
            {scuole!.map( (s,i) => (
              <article key={i} onClick={() => this.setState({ tmp_scuola: s })}>
                <span className={classNames("ui-radio", tmp_scuola && (s.id === tmp_scuola.id) ? "active" : null)} />
                <span>{s.nome}</span>
              </article>
            ))}
            </div>
            <footer>
              <button className="main md btn-block uc" disabled={!tmp_scuola} onClick={() => { if (tmp_scuola) { this.chooseScuola({values: { id_scuola: tmp_scuola.id }}); setTimeout( () => choose(tmp_scuola), 1); }}}><span>Continua</span></button> 
            </footer>
        </Modal>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/AcquistiScuola.tsx